// src/utils/pickerBridge.js
//
// Lightweight bridge for passing a picker page's selection back to the
// page that opened it — the React equivalent of Flutter's
// Navigator.pop(context, result).
//
// Why this exists: React Router v6's navigate(-1, { state }) does NOT
// reliably attach the passed `state` to the location we land on when
// going back in history — the state is silently dropped. Picker pages
// (category / district / division) navigate backwards after a selection
// is made, so relying on router state to carry the result back fails.
// Instead we stash the result in a small in-memory store keyed by "type",
// and the page that opened the picker consumes (and clears) it as soon
// as it lands back on its route.

const _results = new Map();

export function setPickerResult(type, value) {
  _results.set(type, value);
}

export function consumePickerResult(type) {
  if (!_results.has(type)) return null;
  const value = _results.get(type);
  _results.delete(type);
  return value;
}